export enum BETTING_STATUS {
  ENABLED = 1,
  DISABLED = 2,
  BETTING_PAUSED = 3,
}

export enum STAGE {
  UPCOMING = 1,
  LIVE = 2,
  FINISHED = 3,
  CANCELLED = 4,
}

export enum TEMPLATE_ID {
  ONE = 1,
  TWO = 2,
}

export enum EVENT_DETAIL_DISPLAY_TYPE {
  SPLIT = 'SPLIT',
  DRAWER = 'DRAWER',
}

export enum HORSE_RACE_LIST_ID {
  NEXT_N = 'next-5',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
}

export enum INDICATOR {
  HOME_TEAM = 1,
  AWAY_TEAM = 2,
}

export enum BetType {
  MATCH = 'match',
  OUTRIGHT = 'outright',
}

export enum LIST_TYPE {
  EVENT = 'eventList',
  RACE = 'raceList',
  COMPETITION = 'competition',
  MEETINGS = 'meetingsList',
  SUB_NAVIGATION = 'subNavigation',
  COMPETITIONS_GET = 'competitionsGet',
}

export enum SPORT_LIST_ID {
  IN_PLAY = 'live-now',
  TWENTY_FOUR_HRS = '24HRS',
  COMPETITIONS = 'competitions',
  CALENDAR = 'calendar',
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  NEXT = 'next',
}

export enum SPORT_NAV_CATEGORY_LABEL {
  IN_PLAY = 'IN-PLAY',
  HRS_24 = '24HRS',
  COMPETITIONS = 'COMPETITIONS',
  CALENDAR = 'CALENDAR',
  NEXT_5 = 'NEXT 5',
  TODAY = 'TODAY',
  TOMORROW = 'TOMORROW',
  E_FOOTBALL = 'E FOOTBALL',
  E_BASKETBALL = 'E BASKETBALL',
}

export enum RACING_LABEL {
  DIST = 'DIST',
  EW = 'EW',
  PRICE_HISTORY = 'Price history',
  LAST_RUN = 'Last run',
  PERFORMANCE = 'Performance',
  GEAR = 'Gear',
  OWNER = 'Owner',
  JOCKEY_CLAIM = 'Jockey claim',
  SEX = 'Sex',
  SIRE_DAM = 'Sire/Dam',
  BEST_TIME = 'Best Time',
}

export enum SPORT_MULTI_SPORT_LIST_ID {
  IN_PLAY = 'live-now',
  FEATURED = 'default',
}

export enum FEATURED_SPORTS_PAGE_SECTIONS {
  PROMO_SPACE = 'Promo Space',
  IN_PLAY = ' In-Play',
  FEATURED_CASINO = ' Featured Casino',
  TRENDING_BETS = 'Trending Bets',
  HORSE_RACING = 'Horse Racing',
  SUPERCHARGED_BETS_BAR = 'Supercharged Bets Bar',
  UPCOMING_EVENTS = 'Upcoming Events',
  TOP_UPCOMING_FOOTBALL_EVENTS = 'Top Upcoming Football Events',
  TOP_UPCOMING_BASKETBALL_EVENTS = 'Top Upcoming Basketball Events',
  REFER_A_FRIEND = 'Refer A Friend',
  FEEDBACK_FORUM = 'Feedback Forum',
  FOOTBALL_24_HOURS = 'Football 24hrs',
}
